// extracted by mini-css-extract-plugin
export var danger = "_2a-6";
export var lightPink = "_2a-a";
export var medium = "_2a-j";
export var nearSquare = "_2a-m";
export var neutralBlue = "_2a-8";
export var neutralYellow = "_2a-7";
export var noCapitalize = "_2a-1";
export var normal = "_2a-2";
export var pill = "_2a-0";
export var primary = "_2a-3";
export var primaryLight = "_2a-4";
export var shadow = "_2a-n";
export var small = "_2a-k";
export var solidBlack = "_2a-i";
export var solidGreen = "_2a-d";
export var solidLightBlue = "_2a-f";
export var solidNavy = "_2a-e";
export var solidOrange = "_2a-h";
export var solidPink = "_2a-g";
export var solidRed = "_2a-b";
export var solidWhite = "_2a-9";
export var solidYellow = "_2a-c";
export var success = "_2a-5";
export var xsmall = "_2a-l";